<template>
  <div class="cooperation-add-wrapper global-card">
    <bread-crumb />
    <div class="org-mseeage-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%;border-radius:10px;position:relative;"
      >
        <div class="title">
          协议内容
        </div>
        <a-spin
          v-if="detailsLoading"
          style="margin:auto;position:absolute;left:50%;top:50%;"
        />
        <div class="orginfo-wrapper">
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                协议甲方
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_name1 }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                协议乙方
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_name2 }}
              </p>
            </div>
            <!-- <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                目标产品
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.link_products }}
              </p>
            </div> -->
			<!-- <div class="flex-item-content">
			  <p
			    class="flex-item-left"
			    style="text-align:left"
			  >
			    关联资料
			  </p>
			  <div class="flex-item-right"
			    style="text-align:right">
				<div v-for="item in orgInfo.datas">【{{item.link_datas.obj_type_text}}】{{item.link_datas.name}}</div>
				
				</div>
			  
			</div> -->
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                服务预算
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.budget }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                服务地区
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.province_city }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                开始时间
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.service_start_time }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                结束时间
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.service_end_time }}
              </p>
            </div>
          </div>
        </div>
        <div class="title">
          协议服务
        </div>
        <div
          v-for="(item, index) in data2"
          :key="item.id"
          style="display:flex; min-height:100px;margin: 20px 20px 0 30px;background:#F9F9FC;padding:0 20px;"
        >
          <div style="flex-grow:1">
            <div style="margin-top:20px;">
              {{ item.name }}
            </div>
            <div
              style="margin-top:3px;color:#C3C7D5;font-size:14px;margin-bottom:0;line-height:10px;"
            >
              {{ item.summary }}
            </div>
          </div>
          <div
            style="flex-grow:0;width:200px;display:flex;justify-content:center;align-items:center;flex-direction:column;"
          >
            <div style="color:#46D3DD;font-size:16px;">
              {{ item.budget }}元
            </div>
            <div>
              预算价格
            </div>
          </div>
        </div>
        <details-button
          class="form-card-button"
          @onCancel="onCancel"
        />
      </a-card>
    </div>
  </div>
</template>
<script>
import DetailsButton from '../components/DetailsButton.vue';
export default {
  components: { DetailsButton },
  data() {
    return {
      agreement_service: [],
      detailsLoading: false,
      orgInfo: {},
      data2: [],
      Status: undefined,
      form: this.$form.createForm(this),
      provinceData: [],
      cityData: [],
      btnIsLoading: false,
    };
  },
  created() {
    this.$role = this.$store.state.user.role;
    // 获取status
    this.Status = parseInt(this.$route.query.status);
    // 数据回显
    this.getAgreemntInfo({ id: this.$route.query.id });
  },
  methods: {
    // 数据回显
    async getAgreemntInfo(id) {
      let result = await this.$http.post('/agreement/show', id);
      if (result.data.status === 1) {
        let res = result.data.data;
        this.orgInfo = {
          qichacha_name1: res.company_info.team_name,
          qichacha_name2: res.service_provider_info.companyInfo.qichacha_name,
          link_products: res.agreement_product
            .map((item) => {
              return item.title;
            })
            .join('、'),
          budget: res.budget,
          deposit: res.deposit,
          province_city: res.path_txt,
          service_start_time: this.$Format(res.service_start_time),
          service_end_time: this.$Format(res.service_end_time),
		  datas:res.datas
        };
        // 回显
        this.data2 = res.agreement_service.map((item) => {
          return {
            money: item.budget,
            id: item.id,
            name: item.name,
            summary: item.summary,
            budget: item.budget,
          };
        });
      }
    },
    // 取消
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  margin-bottom: 40px;
  .business-scope-wrapper {
    .business-scope-head {
      margin-top: -35px;
      font-size: 16px;
    }
    .business-scope-content {
      background: rgba(249, 249, 252, 1);
      border-radius: 10px;
      padding: 20px;
      margin: 20px 10px;
      min-height: 100px;
    }
  }
  .form-card-wrapper {
    margin-top: 20px;
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-upload {
    .upload-title {
      position: relative;
      top: -9px;
      right: -191px;
      color: #c3c7d5;
      font-size: 12px;
    }
    .ant-upload-text {
      color: #d6daea;
      margin-top: 50px;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 50px -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
      transform: translateY(10px);
  }
  .table-input {
    padding-top: 28px;
    .error-note {
      margin-top: 6px;
      color: #f5222d;
      height: 20px;
    }
  }
  .form-card-title {
    border-left: 1px solid #46d3dd;
    margin-left: -32px;
    padding-left: 20px;
    font-size: 16px;
    color: #565c66;
    .error-note-title {
      color: #f5222d;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .input-number {
    width: 200px;
  }
}
</style>
